import { defineComponent } from "@vue/composition-api";
import './index.scss'
const SectionContent = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, context) {
    return () => {
      return (
        <div class='section-topic-content'>
          <p domPropsInnerHTML={props.item.topicName}></p>
        </div>
      )
    }
  }
})

export default SectionContent

